import './index.css';

import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';
import { NuqsAdapter } from 'nuqs/adapters/react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { injectStoreV2 } from '@/api/APIServicesV2';

import { injectMediaStore } from './api/APIMediaServer';
import { injectStore } from './api/APIServices';
import Loading from './components/misc/Loading';
import { QueryProvider } from './providers/QueryProvider';
import reportWebVitals from './reportWebVitals';
import { MainRouter } from './routes/MainRouter';
import { persistor, store } from './store/root';

// import 'react-tooltip/dist/react-tooltip.css'

// Initialize flag emoji polyfill for Windows/Chromium browser support
polyfillCountryFlagEmojis()

injectStore(store)
injectStoreV2(store)
injectMediaStore(store)

const business = process.env.REACT_APP_BUSINESS

const favicon = document.getElementById('favicon')
switch (business) {
  case 'acenna':
    favicon?.setAttribute('href', '/Acenna2.gif')
    document.title = 'Aceña'
    break
  case 'hermanoscid':
    favicon?.setAttribute('href', '/saborcid.webp')
    document.title = 'Hermanos Cid'
    break
  default:
    favicon?.setAttribute('href', '/logo192.png')
    document.title = 'TECOPOS'
    break
}

const container = document.getElementById('root')!
const root = createRoot(container)
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={<Loading />}>
      <NuqsAdapter>
        <QueryProvider>
          <MainRouter />
        </QueryProvider>
      </NuqsAdapter>
    </PersistGate>
  </Provider>
)

reportWebVitals()
